var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBlueGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99553 0C0.897989 0 0 0.897989 0 1.99553C0 3.09307 0.897989 3.99106 1.99553 3.99106H5.48771C5.78704 3.99106 6.08637 3.99106 6.28592 4.29039C6.48548 4.48994 6.68503 4.6895 6.7848 4.98883L13.2703 24.3455C13.5696 25.2435 13.5696 26.1415 13.3701 27.0394L12.8712 29.1347C12.073 32.2278 14.4676 35.3209 17.7602 35.3209H41.2077C42.3053 35.3209 43.2032 34.4229 43.2032 33.3254C43.2032 32.2278 42.3053 31.3298 41.2077 31.3298H17.7602C16.962 31.3298 16.4631 30.7312 16.6627 29.933L17.0618 28.3365C17.0618 28.0372 17.2613 27.8377 17.4609 27.6381C17.6604 27.4385 17.9598 27.3388 18.2591 27.3388H39.2122C40.0104 27.3388 40.8086 26.8399 41.1079 26.0417L46.2963 10.3768C46.6954 9.07966 45.7974 7.78257 44.4006 7.78257H12.7714C12.4721 7.78257 12.1727 7.78257 11.9732 7.48324C11.7736 7.28369 11.5741 7.08413 11.4743 6.7848L9.57855 1.19732C9.37899 0.498883 8.68056 0 7.78257 0H1.99553Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.363 37.2168C14.1679 37.2168 12.4717 39.0128 12.4717 41.1081C12.4717 43.2034 14.2677 44.9994 16.363 44.9994C18.4583 44.9994 20.2542 43.2034 20.2542 41.1081C20.2542 39.0128 18.4583 37.2168 16.363 37.2168ZM39.7107 37.2168C37.5156 37.2168 35.8194 39.0128 35.8194 41.1081C35.8194 43.2034 37.6154 44.9994 39.7107 44.9994C41.806 44.9994 43.602 43.2034 43.602 41.1081C43.602 39.0128 41.806 37.2168 39.7107 37.2168Z",
    fill: "#57AC2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlueGreen);
export default __webpack_public_path__ + "static/media/cart-blue-green.f2a65109eaf05b0933fe38d09af6a723.svg";
export { ForwardRef as ReactComponent };